(function (scope) {
  "use strict";

  /**
   * @constructor
   * @param {sculpteo.PrintController} controller
   * @param {Viewer} viewer
   * @param {Design} design
   */
  var PrintHowTo = (scope.PrintHowTo = function (controller, design, viewerUI) {
    this.controller = controller;
    this.design = design;
    this.viewerUI = viewerUI;
    this.viewer = viewerUI.viewer;

    var template = "";
    template += "<div class='printHowTo popover tour'>";
    template += "<div class='arrow'></div>";
    template += "<h3 class='popover-title'></h3>";
    template += "<div class='popover-content'></div>";
    template += "<div class='popover-navigation'>";
    template +=
      "<button class='btn btn--xs btn--border-db' data-role='prev'><span class='icon-down-arrow'></span>" +
      gettext("Prev") +
      "</button>";
    template +=
      "<button class='btn btn--xs btn--border-db' data-role='next'>" +
      gettext("Next") +
      "<span class='icon-down-arrow'></button>";
    template +=
      "<button class='btn btn--xs btn--darkblue' data-role='end'>" +
      gettext("End Tutorial") +
      "</button>";
    template += "</div>";
    template += "</div>";

    this.tour = new Tour({
      backdrop: true,
      template: template,
      backdropPadding: 10,
      steps: [
        {
          element: ".PrintPriceView .row.row-no-margin",
          title: gettext("Transparent pricing"),
          content: gettext(
            "This is where you can check the price of your model. Some technologies offer multiple levels of service from Economy and Standard to Express."
          ),
          placement: "auto left",
        },
        {
          element: ".PrintPriceView .row .quantity",
          title: gettext("From 1 to 10.000 units"),
          content: gettext(
            "Units can be changed. We always take the number of units into account so that you’re offered the best possible price."
          ),
          placement: "auto left",
        },
        {
          element: ".PrintPriceView .price-currency-selector",
          title: gettext("Select your currency"),
          content: gettext(
            "Would you like to switch currencies? You can select Dollars, Euros or Pounds Sterling."
          ),
          placement: "auto left",
        },
        {
          element: ".PrintSettingsView .setting-scale",
          title: gettext("Setup the right scale"),
          content: gettext(
            "Input the values you want or use a percentage to set up the scale. You pick the unit you want to define the size of your model."
          ),
          placement: "auto left",
        },
        {
          element: ".PrintSettingsView .setting-process",
          title: gettext("Edit your prints’ settings"),
          content: gettext(
            "You can choose from more than 140 combinations of technologies, materials, finishes, and colors."
          ),
          placement: "auto left",
        },
        {
          element: "#PrintToolsView .print-tool-3D [data-tool='dashboard']",
          title: gettext("Configure your model"),
          content: gettext(
            "The Dashboard mode lets you see and interact with your model and select the 3D Print settings you want."
          ),
          placement: "auto right",
        },
        {
          element: "#PrintToolsView .print-tool-3D",
          title: gettext("Use powerful 3D printing tools"),
          content: gettext(
            "Use our 3D tools to make better prints: Materials Help, Part Orientation, Batch Control, Hollowing and Thickening."
          ),
          placement: "auto right",
        },
        {
          element: "#PrintToolbarView .toolbar-utils .toolbar-views",
          title: gettext("See every aspect of your 3D model"),
          content: gettext(
            "Enjoy different views and discover everything about your 3D model: its solidity, its internal features and its wireframe."
          ),
          placement: "auto top",
        },
        {
          element: "#PrintToolbarView .toolbar-socials",
          title: gettext("Favorite and share your models"),
          content: gettext(
            "Favorite a design and share it easily thanks to these two icons."
          ),
          placement: "auto top",
        },
      ],
      onShown: this.bindEventTag.bind(this),
    });

    $("body").on("click", ".tour-backdrop", this.endTour.bind(this));

    //if this is the first time on the page print and we are not on mobile
    if (
      !localStorage.getItem("is_not_first_time") &&
      $(window).width() >= 768
    ) {
      //we show a message to help new user on the new print by indicating the help button and launch tour
      this.controller.showHelpMessage();

      //set the value
      localStorage.setItem("is_not_first_time", "true");
    }
  });

  /**
   * Start how to tutorial. Set the var force to true to 'force' the tour to start even if the tour has ended
   * force {boolean}
   * @public
   */
  PrintHowTo.prototype.start = function (force) {
    this.tour.init();
    if (force) {
      this.tour.restart();
    } else {
      this.tour.start();
    }

    this.controller.hideHelpMessage();
  };

  /**
   * forced tagCommander to listen to the div
   * we need to to this because the popin is created in JS
   */
  PrintHowTo.prototype.bindEventTag = function () {
    if (window.tagCommander) {
      // window.tagCommander.listen($('.printHowTo'));
    }
  };

  /**
   * end the tour
   */
  PrintHowTo.prototype.endTour = function () {
    this.tour.end();
  };
})((window.sculpteo = window.sculpteo || {}));
